// This (Constant.js) file is used for maintaining constants variable through out the application
(function (module) {
  'use strict';
  module
    .constant('commonDialogMessage', {
      confirmMessage: 'Are you sure you want to delete?',
      accountDeleteMessage: 'Account successfully deleted.',
      accountAdminAccessMessage: 'Admin access updated successfully.',
      orgDeleteEmailMessage: 'You can not delete this blank email address entry.',
      orgDuplicateEmailMessage: 'Entered email address is duplicate for this organization.',
      orgDeleteMessage: 'Organization successfully deleted',
      orgUpdatedMessage: 'Organization successfully updated.',
      orgSavedMessage: 'Organization successfully created.',
      tripDashStatusUpdatedMessage: 'Notes sucessfully created.',
      fieldOptionDeletedMessage: 'Field option successfully deleted.',
      fieldNameSavedMessage: 'Field name successfully created.',
      fieldNameUpdatedMessage: 'Field name successfully updated.',
      fieldNameDeletedMessage: 'Field name successfully deleted.',
      travelerTrackNoResultMessage: 'No travelers found. Please select another search criteria.',
      tripsDashBoardNoResultMessage: 'No trips found. Please select another search criteria.',
      smsHistoryNoResultMessage: 'No SMS history with respective dates. Please select another search criteria.',
      phoneHistoryNoResultMessage: 'No phone history with respective dates. Please select another search criteria.',
      profileFieldsNoResultMessage: 'No profile fields found for this criteria.',
      providerUpdatedMessage: 'Provider successfully updated.',
      providerSavedMessage: 'Provider successfully created.',
      providerDeleteMessage: 'Provider successfully deleted',
      agencySettingsAddMessage: 'Travel agents added successfully.',
      agencySettingsDeletedMessage: 'Travel agent association deleted successfully.',
      iataCodeError: 'Please enter required fields.',
      tripFieldRequiredMessage: 'Please enter all required field',
      dateErrorMessage: 'Please select valid date range',
      duplicateDomainError: 'Entered domain name is duplicate for this organization',
      blankDomainError: 'You can not delete this blank domain name entry',
      checkEmailPassMessage: 'Valid trip link account details must be entered, before adding new entry.Password must contain minimum 8 characters, and must include 1 uppercase letter and 1 digit',
      memberUpdatedMessage: 'Member successfully updated.',
      customerAccountNoResultMessage: 'No customer account found for this criteria.',
      tripFieldNoResultMessage: 'No trip field found for this criteria.',
    });
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/constants/commonDialogMessage.js